import {
  SalaryCalculationContext,
  SalaryCalculationProvider,
} from "./SalaryCalculationContext";
import Tab from "../../../Component/Tab";
import { useContext } from "react";

const Provider = () => {
  const { tabs, setTabs, setSelectedTabIndex, selectedTabIndex, forms } =
    useContext(SalaryCalculationContext);

  return (
    <div>
      <Tab
        tabs={tabs}
        setTabs={setTabs}
        formHome={forms.HOME}
        homeKey={forms.HOME}
        selectedTabIndex={selectedTabIndex}
        setSelectedTabIndex={setSelectedTabIndex}
      />
    </div>
  );
};
const SalaryCalculationPage = (props) => {
  return (
    <SalaryCalculationProvider>
      <Provider {...props} />
    </SalaryCalculationProvider>
  );
};
export default SalaryCalculationPage;
